import React from "react";
import classNames from "classnames/bind";
import styles from "./overlay.module.scss";

const cx = classNames.bind(styles);

const Overlay = ({ onClick }) => {
  return <div onClick={onClick} className={cx("overlay")}></div>;
};

Overlay.PropTypes = {};

export { Overlay as default };
